import { render, staticRenderFns } from "./AppAnomalias.vue?vue&type=template&id=0138b416&scoped=true&"
import script from "./AppAnomalias.vue?vue&type=script&lang=js&"
export * from "./AppAnomalias.vue?vue&type=script&lang=js&"
import style0 from "./AppAnomalias.vue?vue&type=style&index=0&id=0138b416&scoped=true&lang=scss&"
import style1 from "./AppAnomalias.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0138b416",
  null
  
)

export default component.exports